export default function convertBounds(bounds) {
  if (!bounds) return null
  return {
    north: bounds?.ne?.lat,
    east: bounds?.ne?.lng,
    south: bounds?.sw?.lat,
    west: bounds?.sw?.lng,
  }
}
